var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/utils/sites.jinja"] = require( "front/utils/sites.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/TopNav/TopNavPopup.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/TopNav/TopNavPopup.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n";
env.getTemplate("front/utils/sites.jinja", false, "assets/app/front/components/TopNav/TopNavPopup.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
if(Object.prototype.hasOwnProperty.call(t_4, "SITE_AVAILABILITY")) {
var t_7 = t_4.SITE_AVAILABILITY;
} else {
cb(new Error("cannot import 'SITE_AVAILABILITY'")); return;
}
context.setVariable("SITE_AVAILABILITY", t_7);
output += "\n\n<aside class=\"TopNavPopup\" style=\"display: none\">\n\n    <div class=\"TopNavPopup-overlay\"></div>\n\n    <div class=\"TopNavPopup-body\">\n\n        <div class=\"TopNavPopup-scrollbox\">\n            <div class=\"TopNavPopup-content\">\n                <div class=\"TopNavPopup-arrow\">\n                    ";
output += runtime.suppressValue((lineno = 12, colno = 42, runtime.callWrap(runtime.memberLookup((t_1),"svgSprite"), "macros[\"svgSprite\"]", context, ["nav-popup-arrow","0 0 76 42",runtime.makeKeywordArgs({"caller": (function (){var macro_t_8 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_9 = "";;
frame = frame.pop();
return new runtime.SafeString(t_9);
});
return macro_t_8;})()})])), env.opts.autoescape);
output += "\n                </div>\n\n                <nav>\n                    <ul>\n                        <li>\n                            <a href=\"";
output += runtime.suppressValue((lineno = 18, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:join"])), env.opts.autoescape);
output += "\" class=\"";
if((runtime.contextOrFrameLookup(context, frame, "page") == "join")) {
output += "TopNavPopup-navItem--active";
;
}
output += "\">Join</a>\n                            <ul class=\"TopNavPopup-nestedList TopNavPopup-nestedList--opened\">\n                                <li><a href=\"";
output += runtime.suppressValue((lineno = 20, colno = 49, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:join_portfolio_review"])), env.opts.autoescape);
output += "\" class=\"";
if((runtime.contextOrFrameLookup(context, frame, "page") == "join_portfolio_review")) {
output += "TopNavPopup-navItem--active";
;
}
output += "\">Portfolio Review</a></li>\n                            </ul>\n                        </li>\n                        <li>\n                            <a href=\"";
output += runtime.suppressValue((lineno = 24, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:members"])), env.opts.autoescape);
output += "\" class=\"";
if((runtime.contextOrFrameLookup(context, frame, "page") == "members")) {
output += "TopNavPopup-navItem--active";
;
}
output += "\">Directory</a>\n                            <ul class=\"TopNavPopup-nestedList TopNavPopup-nestedList--opened\">\n                                <li><a href=\"";
output += runtime.suppressValue((lineno = 26, colno = 56, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "domain_url"), "domain_url", context, [t_7,"index"])), env.opts.autoescape);
output += "\" target=\"_blank\">AVAILABILITY LIST</a></li>\n                            </ul>\n                        </li>\n                        <li><a href=\"";
output += runtime.suppressValue((lineno = 29, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:events"])), env.opts.autoescape);
output += "\" class=\"";
if((runtime.contextOrFrameLookup(context, frame, "page") == "events")) {
output += "TopNavPopup-navItem--active";
;
}
output += "\">Events</a></li>\n                        <li>\n                            <a href=\"";
output += runtime.suppressValue((lineno = 31, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:awards"])), env.opts.autoescape);
output += "\" class=\"";
if((runtime.contextOrFrameLookup(context, frame, "page") == "awards")) {
output += "TopNavPopup-navItem--active";
;
}
output += "\">Awards</a>\n                            <ul class=\"TopNavPopup-nestedList TopNavPopup-nestedList--opened\">\n                                <li><a href=\"";
output += runtime.suppressValue((lineno = 33, colno = 49, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:awards_adg"])), env.opts.autoescape);
output += "\" class=\"";
if((runtime.contextOrFrameLookup(context, frame, "page") == "awards_adg")) {
output += "TopNavPopup-navItem--active";
;
}
output += "\">ADG Awards</a></li>\n                            </ul>\n                        </li>\n                        <li>\n                            <a href=\"";
output += runtime.suppressValue((lineno = 37, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:guild"])), env.opts.autoescape);
output += "\" class=\"";
if((runtime.contextOrFrameLookup(context, frame, "page") == "guild")) {
output += "TopNavPopup-navItem--active";
;
}
output += "\">The Guild</a>\n                            <ul class=\"TopNavPopup-nestedList TopNavPopup-nestedList--opened\">\n                                <li><a href=\"";
output += runtime.suppressValue((lineno = 39, colno = 49, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:guild_board"])), env.opts.autoescape);
output += "\" class=\"";
if((runtime.contextOrFrameLookup(context, frame, "page") == "guild_board")) {
output += "TopNavPopup-navItem--active";
;
}
output += "\">Board, Council &&nbsp;Committees</a></li>\n                                <li><a href=\"";
output += runtime.suppressValue((lineno = 40, colno = 49, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:guild_staff"])), env.opts.autoescape);
output += "\" class=\"";
if((runtime.contextOrFrameLookup(context, frame, "page") == "guild_staff")) {
output += "TopNavPopup-navItem--active";
;
}
output += "\">Staff & FAQ</a></li>\n                                <li><a href=\"";
output += runtime.suppressValue((lineno = 41, colno = 49, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:guild_production_design_initiative"])), env.opts.autoescape);
output += "\" class=\"";
if((runtime.contextOrFrameLookup(context, frame, "page") == "guild_production_design_initiative")) {
output += "TopNavPopup-navItem--active";
;
}
output += "\">Production Design Initiative</a></li>\n                                <li><a href=\"https://artdirectorsguild.myshopify.com/\">Store</a></li>\n                            </ul>\n                        </li>\n                        <li><a href=\"";
output += runtime.suppressValue((lineno = 45, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:perspective"])), env.opts.autoescape);
output += "\" class=\"";
if((runtime.contextOrFrameLookup(context, frame, "page") == "perspective")) {
output += "TopNavPopup-navItem--active";
;
}
output += "\">Perspective</a></li>\n                        ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "request")),"user")),"member")) {
output += "\n                            <li><a href=\"";
output += runtime.suppressValue((lineno = 47, colno = 45, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:myadg"])), env.opts.autoescape);
output += "\" class=\"TopNavPopup-navItem--myadg ";
if((runtime.contextOrFrameLookup(context, frame, "page") == "myadg")) {
output += "TopNavPopup-navItem--active";
;
}
output += "\">";
output += runtime.suppressValue((lineno = 47, colno = 177, runtime.callWrap(runtime.memberLookup((t_1),"svgSprite"), "macros[\"svgSprite\"]", context, ["menu-myadg","0 0 22 27",runtime.makeKeywordArgs({"caller": (function (){var macro_t_10 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_11 = "";;
frame = frame.pop();
return new runtime.SafeString(t_11);
});
return macro_t_10;})()})])), env.opts.autoescape);
output += " My ADG</a></li>\n                            <li><a href=\"";
output += runtime.suppressValue((lineno = 48, colno = 45, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:rates"])), env.opts.autoescape);
output += "\" class=\"TopNavPopup-navItem--rates ";
if((runtime.contextOrFrameLookup(context, frame, "page") == "rates")) {
output += "TopNavPopup-navItem--active";
;
}
output += "\">";
output += runtime.suppressValue((lineno = 48, colno = 177, runtime.callWrap(runtime.memberLookup((t_1),"svgSprite"), "macros[\"svgSprite\"]", context, ["menu-rates","0 0 28 25",runtime.makeKeywordArgs({"caller": (function (){var macro_t_12 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_13 = "";;
frame = frame.pop();
return new runtime.SafeString(t_13);
});
return macro_t_12;})()})])), env.opts.autoescape);
output += " Rates & Contracts</a></li>\n                            <li><a href=\"";
output += runtime.suppressValue((lineno = 49, colno = 45, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:dues"])), env.opts.autoescape);
output += "\" class=\"TopNavPopup-navItem--dues ";
if((runtime.contextOrFrameLookup(context, frame, "page") == "dues")) {
output += "TopNavPopup-navItem--active";
;
}
output += "\">";
output += runtime.suppressValue((lineno = 49, colno = 174, runtime.callWrap(runtime.memberLookup((t_1),"svgSprite"), "macros[\"svgSprite\"]", context, ["menu-benefits","0 0 26 26",runtime.makeKeywordArgs({"caller": (function (){var macro_t_14 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_15 = "";;
frame = frame.pop();
return new runtime.SafeString(t_15);
});
return macro_t_14;})()})])), env.opts.autoescape);
output += " Dues</a></li>\n                            <li><a href=\"";
output += runtime.suppressValue((lineno = 50, colno = 45, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:benefits"])), env.opts.autoescape);
output += "\" class=\"TopNavPopup-navItem--benefits ";
if((runtime.contextOrFrameLookup(context, frame, "page") == "benefits")) {
output += "TopNavPopup-navItem--active";
;
}
output += "\">";
output += runtime.suppressValue((lineno = 50, colno = 186, runtime.callWrap(runtime.memberLookup((t_1),"svgSprite"), "macros[\"svgSprite\"]", context, ["menu-faq","0 0 26 26",runtime.makeKeywordArgs({"caller": (function (){var macro_t_16 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_17 = "";;
frame = frame.pop();
return new runtime.SafeString(t_17);
});
return macro_t_16;})()})])), env.opts.autoescape);
output += " Benefits</a></li>\n                            <li><a href=\"";
output += runtime.suppressValue((lineno = 51, colno = 45, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:faq"])), env.opts.autoescape);
output += "\" class=\"TopNavPopup-navItem--faq ";
if((runtime.contextOrFrameLookup(context, frame, "page") == "faq")) {
output += "TopNavPopup-navItem--active";
;
}
output += "\">";
output += runtime.suppressValue((lineno = 51, colno = 171, runtime.callWrap(runtime.memberLookup((t_1),"svgSprite"), "macros[\"svgSprite\"]", context, ["menu-logout","0 0 22 22",runtime.makeKeywordArgs({"caller": (function (){var macro_t_18 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_19 = "";;
frame = frame.pop();
return new runtime.SafeString(t_19);
});
return macro_t_18;})()})])), env.opts.autoescape);
output += " Faq</a></li>\n                            <li><a class=\"TopNavPopup-navItem--logout\">LogOut</a></li>\n                        ";
;
}
else {
output += "\n                            <li><a href=\"";
output += runtime.suppressValue((lineno = 54, colno = 45, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:login-popup"])), env.opts.autoescape);
output += "\" class=\"TopNavPopup-navItem--login u-Route\">";
output += runtime.suppressValue((lineno = 54, colno = 134, runtime.callWrap(runtime.memberLookup((t_1),"svgSprite"), "macros[\"svgSprite\"]", context, ["menu-myadg","0 0 22 27",runtime.makeKeywordArgs({"caller": (function (){var macro_t_20 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_21 = "";;
frame = frame.pop();
return new runtime.SafeString(t_21);
});
return macro_t_20;})()})])), env.opts.autoescape);
output += " Member Log in</a></li>\n                        ";
;
}
output += "\n\n                    </ul>\n                </nav>\n\n                <footer class=\"TopNavPopup-footer\">\n\n                    <div class=\"TopNavPopup-footerWrapper\">\n                        <div class=\"TopNavPopup-footerColumnsWrapper\">\n                            <ul class=\"TopNavPopup-footerColumn\">\n                                <li><a href=\"";
output += runtime.suppressValue((lineno = 65, colno = 49, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:contact"])), env.opts.autoescape);
output += "\">Contact</a></li>\n                                <li><a href=\"";
output += runtime.suppressValue((lineno = 66, colno = 56, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "domain_url"), "domain_url", context, [t_7,"index"])), env.opts.autoescape);
output += "\">Availability List</a></li>\n                                <li><a href=\"";
output += runtime.suppressValue((lineno = 67, colno = 49, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:archives"])), env.opts.autoescape);
output += "\">ADG Archives</a></li>\n                                <li><a href=\"";
output += runtime.suppressValue((lineno = 68, colno = 49, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:perspective"])), env.opts.autoescape);
output += "\">Perspective</a></li>\n                                <li><a href=\"";
output += runtime.suppressValue((lineno = 69, colno = 49, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:media"])), env.opts.autoescape);
output += "\">Media</a></li>\n                                <li><a href=\"";
output += runtime.suppressValue((lineno = 70, colno = 49, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:press"])), env.opts.autoescape);
output += "\">Press</a></li>\n                                <li>\n                                    <div class=\"TopNavPopup-footerAddress\">\n                                        ";
output += runtime.suppressValue(env.getFilter("safe").call(context, env.getFilter("nl2br").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "footer")),"address"))), env.opts.autoescape);
output += "\n                                        <a href=\"https://www.google.com/maps/place/11969+Ventura+Blvd,+Studio+City,+CA+91604,+USA/@34.1437329,-118.3948317,17z/data=!3m1!4b1!4m5!3m4!1s0x80c2be07f9fa4a93:0x6285b8ff97f6c3d8!8m2!3d34.1437329!4d-118.392643\" target=\"_blank\">MAP</a><br>\n                                        <br>\n                                        <a href=\"tel:818-762-9995\">(818) 762-9995</a><br>\n                                    </div>\n                                </li>\n                            </ul>\n\n                            <ul class=\"TopNavPopup-footerColumn\">\n                                <li><a href=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "footer")),"instagram"), env.opts.autoescape);
output += "\" target=\"_blank\">Instagram</a></li>\n                                <li><a href=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "footer")),"facebook"), env.opts.autoescape);
output += "\" target=\"_blank\">Facebook</a></li>\n                                <li><a href=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "footer")),"twitter"), env.opts.autoescape);
output += "\" target=\"_blank\">Twitter</a></li>\n                                <li>\n                                    <div class=\"TopNavPopup-footerLogo\">\n                                        ";
output += runtime.suppressValue((lineno = 87, colno = 62, runtime.callWrap(runtime.memberLookup((t_1),"svgSprite"), "macros[\"svgSprite\"]", context, ["logo","0 0 160 150",runtime.makeKeywordArgs({"caller": (function (){var macro_t_22 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_23 = "";;
frame = frame.pop();
return new runtime.SafeString(t_23);
});
return macro_t_22;})()})])), env.opts.autoescape);
output += "\n                                    </div>\n                                </li>\n                                <li class=\"TopNavPopup-footerColumnItem--small\"><a href=\"";
output += runtime.suppressValue((lineno = 90, colno = 93, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:privacy"])), env.opts.autoescape);
output += "\" target=\"_blank\">Privacy Policy</a></li>\n                                <li class=\"TopNavPopup-footerColumnItem--small\"><a href=\"";
output += runtime.suppressValue((lineno = 91, colno = 93, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:terms"])), env.opts.autoescape);
output += "\" target=\"_blank\">Terms of Use</a></li>\n                                <li class=\"TopNavPopup-footerColumnItem--small\"><a href=\"http://www.iatse.net\" target=\"_blank\">The Iatse</a></li>\n                            </ul>\n\n                        </div>\n\n                        <div class=\"TopNavPopup-footerCopyright\">IATSE Local 800  /  © 2018 ADG</div>\n                    </div>\n\n                </footer>\n\n            </div>\n        </div>\n\n    </div>\n</aside>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/TopNav/TopNavPopup.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/TopNav/TopNavPopup.jinja
// module id = 532
// module chunks = 0